import { CheckPriorAuthInputV4 } from '@getvim/payer-types';
import gql from 'graphql-tag';
import { gqlClient } from '../../../gql-client';
import { logger } from '@getvim/vim-connect-logger';
import { Insurer } from '@getvim-os/standard';
import { CheckPriorAuthInput, CheckPriorAuthResponse } from '../../../../../graphql';

const priorAuthLogger = logger.scope('Prior Auth queries');

const checkPriorAuthQueryOld = gql`
  query CheckPriorAuth($input: CheckPriorAuthInputV4!) {
    checkPriorAuth(input: $input) {
      procedures {
        code
        description
        decisionSummary
        sitesOfService {
          name
          decision
          code
          conditionsList
        }
      }
      productType
      state
      disclaimer
    }
  }
`;

const checkPriorAuthQuery = gql`
  query CheckPriorAuthorization($input: CheckPriorAuthInput!) {
    checkPriorAuthorization(input: $input) {
      procedures {
        code
        description
        decisionSummary
        sitesOfService {
          name
          decision
          code
          conditionsList
        }
      }
      productType
      state
      disclaimer
    }
  }
`;

export const checkPriorAuthGQLQueryOld = async (
  input: CheckPriorAuthInputV4,
  insurer?: Insurer,
): Promise<CheckPriorAuthResponse> => {
  try {
    const { data } = await gqlClient.query({
      query: checkPriorAuthQueryOld,
      variables: { input },
      fetchPolicy: 'no-cache',
      context: {
        uri: '/prior-auth/api/graphql',
        ...(insurer && {
          headers: {
            'x-insurer': insurer,
          },
        }),
      },
    });
    return { data: data?.checkPriorAuth };
  } catch (error: any) {
    priorAuthLogger.error('Failed check prior auth query', { error, input });
    return { error };
  }
};

export const checkPriorAuthGQLQuery = async (
  input: CheckPriorAuthInput,
  insurer?: Insurer,
): Promise<CheckPriorAuthResponse> => {
  try {
    const { data } = await gqlClient.query({
      query: checkPriorAuthQuery,
      variables: { input },
      fetchPolicy: 'no-cache',
      context: {
        uri: '/prior-auth/api/graphql',
        ...(insurer && {
          headers: {
            'x-insurer': insurer,
          },
        }),
      },
    });
    return { data: data?.checkPriorAuthorization };
  } catch (error: any) {
    priorAuthLogger.error('Failed check prior auth query', { error, input });
    return { error };
  }
};
